module.exports = __webpack_public_path__ + "img/default.444c942f.jpg";